import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "keyword-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "제목 진단"),
  /*#__PURE__*/_createElementVNode("p", { class: "page-desc" }, [
    /*#__PURE__*/_createTextVNode(" 쓰려는 제목을 넣으면 "),
    /*#__PURE__*/_createElementVNode("strong", null, "검색 수요·경쟁·형식"),
    /*#__PURE__*/_createTextVNode("을 100점으로 채점하고, 더 나은 제목 후보를 제안합니다. ")
  ])
], -1)
const _hoisted_3 = { class: "search-card" }
const _hoisted_4 = { class: "seed-row" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "hint-line" }, " 제목을 그대로 붙여 넣으세요. 문장에서 단어를 뽑아 실제 검색량과 대조합니다. ", -1)
const _hoisted_7 = {
  key: 0,
  class: "notice notice-error"
}
const _hoisted_8 = {
  key: 1,
  class: "loading-panel"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "lp-bar" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1)
const _hoisted_10 = { class: "lp-stage" }
const _hoisted_11 = { class: "lp-meta" }
const _hoisted_12 = { class: "lp-elapsed" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "lp-hint" }, "보통 10~15초 걸립니다", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "lp-note" }, [
  /*#__PURE__*/_createTextVNode(" 제목의 낱말을 "),
  /*#__PURE__*/_createElementVNode("b", null, "서로 조합해"),
  /*#__PURE__*/_createTextVNode(" 실제 검색량이 있는지 하나씩 확인합니다. 연관 목록에 없는 키워드도 이렇게 찾아냅니다. ")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "notice notice-warn"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "part-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ph-no" }, "1"),
  /*#__PURE__*/_createElementVNode("span", { class: "ph-text" }, "입력한 제목 진단"),
  /*#__PURE__*/_createElementVNode("span", { class: "ph-sub" }, "지금 제목이 어떤 상태인가")
], -1)
const _hoisted_17 = { class: "sc-left" }
const _hoisted_18 = { class: "sc-score" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "/100", -1)
const _hoisted_20 = { class: "sc-grade" }
const _hoisted_21 = { class: "sc-right" }
const _hoisted_22 = { class: "sc-title" }
const _hoisted_23 = { class: "sc-summary" }
const _hoisted_24 = { class: "detail-card" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "항목별 점수", -1)
const _hoisted_26 = { class: "sr-head" }
const _hoisted_27 = { class: "sr-label" }
const _hoisted_28 = { class: "sr-num" }
const _hoisted_29 = { class: "sr-track" }
const _hoisted_30 = { class: "sr-comment" }
const _hoisted_31 = { class: "detail-card" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "이 제목이 담고 있는 검색 키워드", -1)
const _hoisted_33 = {
  key: 0,
  class: "matched-list"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "mt-vol" }
const _hoisted_36 = { class: "mt-pos" }
const _hoisted_37 = {
  key: 1,
  class: "dc-note"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "part-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ph-no" }, "2"),
  /*#__PURE__*/_createElementVNode("span", { class: "ph-text" }, "대신 쓸 제목"),
  /*#__PURE__*/_createElementVNode("span", { class: "ph-sub" }, "검색되는 키워드로 다시 지은 후보")
], -1)
const _hoisted_39 = { class: "suggest-grid" }
const _hoisted_40 = { class: "detail-card" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "키워드 중심 후보", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "dc-note top" }, [
  /*#__PURE__*/_createElementVNode("b", null, "검색어를 앞세운 짧은 제목"),
  /*#__PURE__*/_createTextVNode("입니다. 노출을 먼저 노릴 때 씁니다. 그대로 쓰기보다 "),
  /*#__PURE__*/_createElementVNode("b", null, "내 글 내용에 맞게 고쳐"),
  /*#__PURE__*/_createTextVNode(" 쓰세요. ")
], -1)
const _hoisted_43 = { class: "suggest-list" }
const _hoisted_44 = { class: "sg-title" }
const _hoisted_45 = {
  key: 0,
  class: "sg-cat"
}
const _hoisted_46 = { class: "sg-meta" }
const _hoisted_47 = { class: "sg-kw" }
const _hoisted_48 = { class: "sg-vol" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "sg-reason" }
const _hoisted_51 = {
  key: 0,
  class: "dc-note"
}
const _hoisted_52 = { class: "detail-card ai-card" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "dc-title" }, "문장형 후보", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "dc-note top" }, [
  /*#__PURE__*/_createTextVNode(" 지금 제목의 "),
  /*#__PURE__*/_createElementVNode("b", null, "약점과 노릴 키워드"),
  /*#__PURE__*/_createTextVNode("를 반영해 상위 노출을 노리는 문장으로 지었습니다. 갈래(정리·경험·비교·질문·주의·방법)가 겹치지 않게 만듭니다. ")
], -1)
const _hoisted_55 = {
  key: 0,
  class: "notice notice-warn"
}
const _hoisted_56 = {
  key: 1,
  class: "suggest-list"
}
const _hoisted_57 = { class: "sg-title" }
const _hoisted_58 = {
  key: 0,
  class: "sg-cat"
}
const _hoisted_59 = { class: "sg-meta" }
const _hoisted_60 = {
  key: 0,
  class: "sg-kw"
}
const _hoisted_61 = {
  key: 1,
  class: "sg-vol"
}
const _hoisted_62 = {
  key: 2,
  class: "sg-none"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "sg-reason" }
const _hoisted_65 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("b", null, "진단", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
          class: "seed-input",
          type: "text",
          placeholder: "예: 여의도 점심 삼계탕 맛집 다녀온 후기",
          maxlength: "120",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.analyze && _ctx.analyze(...args)), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.title]
        ]),
        _createElementVNode("button", {
          class: "btn-search",
          disabled: _ctx.loading,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.analyze && _ctx.analyze(...args)))
        }, _toDisplayString(_ctx.loading ? "분석 중…" : "진단"), 9, _hoisted_5)
      ]),
      _hoisted_6
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.stage), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.elapsed) + "초 경과", 1),
            _hoisted_13
          ]),
          _hoisted_14
        ]))
      : (_ctx.result)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.result.quotaWarning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.result.quotaWarning), 1))
              : _createCommentVNode("", true),
            _hoisted_16,
            _createElementVNode("section", {
              class: _normalizeClass(["score-card", _ctx.gradeClass])
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.result.score), 1),
                  _hoisted_19
                ]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.result.grade), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.result.title), 1),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.result.summary), 1)
              ])
            ], 2),
            _createElementVNode("section", _hoisted_24, [
              _hoisted_25,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.items, (it) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: it.label,
                  class: "score-row"
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(it.label), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(it.score) + " / " + _toDisplayString(it.max), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["sr-fill", _ctx.barClass(it.score, it.max)]),
                      style: _normalizeStyle({ width: (it.score / it.max * 100) + '%' })
                    }, null, 6)
                  ]),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(it.comment), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("section", _hoisted_31, [
              _hoisted_32,
              (_ctx.result.matched && _ctx.result.matched.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.matched, (m) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: m.keyword,
                        class: "mt-item"
                      }, [
                        _createElementVNode("a", {
                          class: "mt-kw",
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.goSearch(m.keyword)), ["prevent"])
                        }, _toDisplayString(m.keyword), 9, _hoisted_34),
                        _createElementVNode("span", _hoisted_35, "월 " + _toDisplayString(m.volume.toLocaleString()) + "회", 1),
                        (m.saturation !== null)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["mt-sat", _ctx.satClass(m.saturation)])
                            }, " 포화도 " + _toDisplayString(m.saturation.toFixed(2)), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(m.position === 0 ? "제목 맨 앞" : "앞에서 " + m.position + "번째 글자"), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_37, " 제목에서 실제로 검색되는 키워드를 찾지 못했습니다. 아래 추천 제목처럼 사람들이 검색하는 표현을 넣어 보세요. "))
            ]),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("section", _hoisted_40, [
                _hoisted_41,
                _hoisted_42,
                _createElementVNode("ul", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.suggestions, (s) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: s.title,
                      class: "sg-item"
                    }, [
                      _createElementVNode("div", _hoisted_44, [
                        (s.category)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(s.category), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(s.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", _hoisted_47, _toDisplayString(s.baseKeyword), 1),
                        _createElementVNode("span", _hoisted_48, "월 " + _toDisplayString(s.volume.toLocaleString()) + "회", 1),
                        _createElementVNode("button", {
                          class: "sg-copy",
                          onClick: ($event: any) => (_ctx.copy(s.title))
                        }, "복사", 8, _hoisted_49)
                      ]),
                      _createElementVNode("div", _hoisted_50, _toDisplayString(s.reason), 1)
                    ]))
                  }), 128))
                ]),
                (!_ctx.result.suggestions || !_ctx.result.suggestions.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_51, " 추천할 만한 키워드를 찾지 못했습니다. 더 일반적인 단어를 포함해 보세요. "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("section", _hoisted_52, [
                _hoisted_53,
                _hoisted_54,
                (_ctx.result.aiMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.result.aiMessage), 1))
                  : _createCommentVNode("", true),
                (_ctx.result.aiSuggestions && _ctx.result.aiSuggestions.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.aiSuggestions, (s) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: s.title,
                          class: _normalizeClass(["sg-item", { weak: !s.baseKeyword }])
                        }, [
                          _createElementVNode("div", _hoisted_57, [
                            (s.category)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(s.category), 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(s.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            (s.baseKeyword)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(s.baseKeyword), 1))
                              : _createCommentVNode("", true),
                            (s.baseKeyword)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, "월 " + _toDisplayString(s.volume.toLocaleString()) + "회", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_62, "검색 키워드 없음")),
                            _createElementVNode("button", {
                              class: "sg-copy",
                              onClick: ($event: any) => (_ctx.copy(s.title))
                            }, "복사", 8, _hoisted_63)
                          ]),
                          _createElementVNode("div", _hoisted_64, _toDisplayString(s.reason), 1)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 64))
        : (!_ctx.loading && !_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _createTextVNode(" 쓰려는 제목을 입력하고 "),
              _hoisted_66,
              _createTextVNode("을 눌러 보세요. ")
            ]))
          : _createCommentVNode("", true)
  ]))
}